import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { AlertModule } from '../alert/alert.module';

import { CartComponent } from './cart.component';

import { SnackBarService } from '../../services/snack-bar.service';
import { MobileDropdownModule } from '../mobile-dropdown/mobile-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    MatDividerModule,
    FormsModule,
    
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    AlertModule,
    ReactiveFormsModule,
    MobileDropdownModule
  ],
  exports: [
    CartComponent
  ],
  providers: [
    SnackBarService
  ],
  declarations: [
    CartComponent
  ]
})
export class CartModule { }

